export default __webpack_public_path__ + "static/near_miami_back-e4ebb2a587f671972b82ee0f96bc672b.webp";